<button class="jump-to-current-time-button"
	@fadeInScale
	*ngIf="scrollDirection != null"
	(click)="onClick()"
	[attr.aria-label]="'transcript-viewer_jump-to-current-time' | translate"
	[matTooltip]="'transcript-viewer_jump-to-current-time' | translate">
	<i [class]="icon"></i>
</button>
